class ProfileCtrl {
    constructor($scope, $element, $compile, $http, UtilsService) {
        this.$scope = $scope;
        this.$http = $http;
        this.UtilsService = UtilsService;
        this.$compile = $compile;
        this.contact = {};
        this.base = {};
        this.state = {};
        this.file = { name: null, validationErrors: [], validating: false };
        this.isDragOver = false;
        this.autorefreshTime = window.autorefreshTime;
        this.state.recruitmentId = window.recruitmentId;
        this.showRecruitmentInfo = this.getShowRecruitmentInfoFromLocalStorage();
    }

    $onInit() {
        this.state.poland = window.statics.poland;

        this.autoRefresh(this.autorefreshTime);
    }

    init(property, variableName) {
        this[property] = window[variableName];
    }

    getShowRecruitmentInfoFromLocalStorage() {
        const storageItem = window.localStorage.getItem(this.getShowRecruitmentInfoKey());

        return storageItem !== "false";
    }

    toggleRecruitmentInfo() {
        this.setShowRecruitmentInfoToLocalStorage();
        this.showRecruitmentInfo = !this.showRecruitmentInfo;
    }

    setShowRecruitmentInfoToLocalStorage() {
        window.localStorage.setItem(this.getShowRecruitmentInfoKey(), !this.showRecruitmentInfo);
    }

    getShowRecruitmentInfoKey() {
        return 'showRecruitmentInfo_' + this.state.recruitmentId;
    }

    isSendButtonDisabled() {
        return !this.file.name || this.file.validating || this.file.validationErrors.length > 0;
    }

    shouldShowServerErrors() {
        return !this.file.name;
    }

    autoRefresh(autoRefreshTime) {
        if(!autoRefreshTime || 0 === autoRefreshTime) {
            return;
        }

        window.setTimeout(
            function () {
                document.location.reload();
            },
            autoRefreshTime
        );
    }
}
ProfileCtrl.$inject = ['$scope', '$element', '$compile', '$http', 'UtilsService'];

export default ProfileCtrl;
